export default __webpack_public_path__ + "static/media/fortmatic-logo.42ceea86.svg";